
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lyoVb = parcelRequire("lyoVb");
function $10c7ec3ed0750b59$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
}
function $10c7ec3ed0750b59$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(12);
    const r = 0.1 + Math.sin((0, $lyoVb.frameN) * TAU) * 0.05;
    const d = 0.01 + Math.sin((0, $lyoVb.frameN) * TAU + PI) * 0.05;
    const g = d * 2;
    const n = 15;
    const dt = HALF_PI / (n - 1);
    const w0 = 2 * r + d;
    const off = w0 / 2;
    rotate(PI * (0, $lyoVb.frameN));
    fill(0, 40, 70);
    stroke(0, 40, 70);
    for(let yoff = 0.5 - 15 * w0; yoff < 1 + 4 * w0; yoff += w0 + g)for(let xoff = 0.5 - 15 * w0; xoff < 1 + 4 * w0; xoff += w0 + g){
        beginShape();
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t) * r + xoff - off;
            const y = Math.sin(t) * r + yoff - off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t - HALF_PI) * r + xoff - off;
            const y = Math.sin(t - HALF_PI) * r + yoff + off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t - PI) * r + xoff + off;
            const y = Math.sin(t - PI) * r + yoff + off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t + HALF_PI) * r + xoff + off;
            const y = Math.sin(t + HALF_PI) * r + yoff - off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        endShape(CLOSE);
    }
    fill(290, 20, 60);
    stroke(290, 20, 60);
    for(let yoff = 0.5 - 15 * w0 - off - g / 2; yoff < 1 + 4 * w0; yoff += w0 + g)for(let xoff = 0.5 - 15 * w0 - off - g / 2; xoff < 1 + 4 * w0; xoff += w0 + g){
        beginShape();
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t) * r + xoff - off;
            const y = Math.sin(t) * r + yoff - off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t - HALF_PI) * r + xoff - off;
            const y = Math.sin(t - HALF_PI) * r + yoff + off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t - PI) * r + xoff + off;
            const y = Math.sin(t - PI) * r + yoff + off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        [
            ...Array(n).keys()
        ].forEach((i)=>{
            const t = i * dt;
            const x = Math.cos(t + HALF_PI) * r + xoff + off;
            const y = Math.sin(t + HALF_PI) * r + yoff - off;
            vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y));
        });
        endShape(CLOSE);
    }
    noStroke();
    fill(290, 20, 60);
    for(let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    for(let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    fill(0, 40, 70);
    for(let yoff = 0.5 - 15 * w0 - off - g / 2; yoff < 1 + 3 * w0; yoff += w0 + g)for(let xoff = 0.5 - 15 * w0 - off - g / 2; xoff < 1 + 3 * w0; xoff += w0 + g){
        const x = xoff - g / 2;
        const y = yoff + r + d;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(g), (0, $lyoVb.h)(d));
    }
    fill(290, 20, 60);
    for(let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    for(let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    fill(0, 40, 70);
    for(let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    for(let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    fill(290, 20, 60);
    for(let yoff = 0.5 - 15 * w0 - w0 - g; yoff < 1 + 3 * w0; yoff += w0 + g)for(let xoff = 0.5 - 15 * w0 - w0 - g; xoff < 1 + 3 * w0; xoff += w0 + g){
        const x = xoff - g / 2;
        const y = yoff + r + d;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(g), (0, $lyoVb.h)(d));
    }
    fill(0, 40, 70);
    for(let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
    for(let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g))for(let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)){
        const x = xoff + r + d;
        const y = yoff - g / 2;
        rect((0, $lyoVb.w)(x), (0, $lyoVb.h)(y), (0, $lyoVb.w)(d), (0, $lyoVb.h)(g));
    }
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $87168bd88f034e11$var$source = "import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from '../js/common.js';\n\nexport function setup() {\n	setupCommon();\n}\n\nexport function draw() {\n	drawCommon();\n	background(12);\n\n	const r = 0.1 + Math.sin(frameN * TAU) * 0.05;\n	const d = 0.01 + Math.sin(frameN * TAU + PI) * 0.05;\n	const g = d * 2;\n	const n = 15;\n	const dt = HALF_PI / (n - 1);\n	const w0 = 2 * r + d;\n	const off = w0 / 2;\n\n	rotate(PI * frameN);\n	fill(0, 40, 70);\n	stroke(0, 40, 70);\n	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 4 * w0; yoff += w0 + g) {\n		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 4 * w0; xoff += w0 + g) {\n			beginShape();\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t) * r + xoff - off;\n				const y = Math.sin(t) * r + yoff - off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t - HALF_PI) * r + xoff - off;\n				const y = Math.sin(t - HALF_PI) * r + yoff + off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t - PI) * r + xoff + off;\n				const y = Math.sin(t - PI) * r + yoff + off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t + HALF_PI) * r + xoff + off;\n				const y = Math.sin(t + HALF_PI) * r + yoff - off;\n				vertex(w(x), h(y));\n			});\n			endShape(CLOSE);\n		}\n	}\n\n	fill(290, 20, 60);\n	stroke(290, 20, 60);\n	for (let yoff = 0.5 - 15 * w0 - off - (g / 2); yoff < 1 + 4 * w0; yoff += w0 + g) {\n		for (let xoff = 0.5 - 15 * w0 - off - (g / 2); xoff < 1 + 4 * w0; xoff += w0 + g) {\n			beginShape();\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t) * r + xoff - off;\n				const y = Math.sin(t) * r + yoff - off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t - HALF_PI) * r + xoff - off;\n				const y = Math.sin(t - HALF_PI) * r + yoff + off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t - PI) * r + xoff + off;\n				const y = Math.sin(t - PI) * r + yoff + off;\n				vertex(w(x), h(y));\n			});\n			[...Array(n).keys()].forEach(i => {\n				const t = i * dt;\n				const x = Math.cos(t + HALF_PI) * r + xoff + off;\n				const y = Math.sin(t + HALF_PI) * r + yoff - off;\n				vertex(w(x), h(y));\n			});\n			endShape(CLOSE);\n		}\n	}\n\n	noStroke();\n\n	fill(290, 20, 60);\n	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n	for (let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n\n\n	fill(0, 40, 70);\n	for (let yoff = 0.5 - 15 * w0 - off - (g / 2); yoff < 1 + 3 * w0; yoff += w0 + g) {\n		for (let xoff = 0.5 - 15 * w0 - off - (g / 2); xoff < 1 + 3 * w0; xoff += w0 + g) {\n			const x = xoff - g / 2;\n			const y = yoff + r + d;\n			rect(w(x), h(y), w(g), h(d));\n		}\n	}\n\n	fill(290, 20, 60);\n	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n	for (let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n\n	fill(0, 40, 70);\n	for (let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n	for (let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n\n	fill(290, 20, 60);\n	for (let yoff = 0.5 - 15 * w0 - w0 - g; yoff < 1 + 3 * w0; yoff += w0 + g) {\n		for (let xoff = 0.5 - 15 * w0 - w0 - g; xoff < 1 + 3 * w0; xoff += w0 + g) {\n			const x = xoff - g / 2;\n			const y = yoff + r + d;\n			rect(w(x), h(y), w(g), h(d));\n		}\n	}\n\n	fill(0, 40, 70);\n	for (let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n	for (let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {\n		for (let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {\n			const x = xoff + r + d;\n			const y = yoff - g / 2;\n			rect(w(x), h(y), w(d), h(g));\n		}\n	}\n}\n";
(0, $gPx2I.make)({
    setup: $10c7ec3ed0750b59$export$de27182ff8187d6c,
    draw: $10c7ec3ed0750b59$export$e529deb2bfd496dc
}, $87168bd88f034e11$var$source);


//# sourceMappingURL=12.f778fb66.js.map
